const customerServiceRouter = [{
	path: 'customerLogin',
	name: 'customerLogin',
  	component: resolve => require(['@views/customerService/customerLogin'],resolve),
	meta:{
		title: '用户登录',
		belong: 'customerService'
	}
},{
	path: 'erectorPage',
	name: 'erectorPage',
  	component: resolve => require(['@views/customerService/erectorPage'],resolve),
	meta:{
		title: '安装',
		belong: 'customerService'
	}
},{
	path: 'customerPageOne',
	name: 'customerPageOne',
  	component: resolve => require(['@views/customerService/customerPageOne'],resolve),
	meta:{
		title: '用户评价',
		belong: 'customerService'
	}
},{
	path: 'customerPageTwo',
	name: 'customerPageTwo',
  	component: resolve => require(['@views/customerService/customerPageTwo'],resolve),
	meta:{
		title: '用户评价',
		belong: 'customerService'
	}
},{
	path: 'agencyPage',
	name: 'agencyPage',
  	component: resolve => require(['@views/customerService/agencyPage'],resolve),
	meta:{
		title: '处理',
		belong: 'customerService'
	}
},{
	path: 'serviceList',
	name: 'serviceList',
  	component: resolve => require(['@views/customerService/serviceList'],resolve),
	meta:{
		title: '美心门',
		belong: 'customerService'
	}
},{
	path: 'csi',
	name: 'csi',
  	component: resolve => require(['@views/customerService/customerServiceIndex'],resolve),
	meta:{
		title: '美心门',
		belong: 'customerService'
	}
},{
	path: 'complainPage',
	name: 'complainPage',
  	component: resolve => require(['@views/customerService/complainPage'],resolve),
	meta:{
		title: '投诉',
		belong: 'customerService'
	}
}]

export default customerServiceRouter;


// WEBPACK FOOTER //
// ./src/router/customerService/index.js